import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import ComplianceForm from "./ComplianceController/ComplianceForm";

import { useGetComplianceDetailQuery, useUpdateComplianceMutation } from "store/services/complianceApi";

import { useAppMeta } from "hooks";
const ComplianceEditScreen = () => {


  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Compliance", path: "/app/crm/compliance/list" },
    { title: "Edit Compliance" },
  ];

  // RTK Query
  const {
    data: complianceDetail,
    isLoading: loadingCompliance,
    error,
  } = useGetComplianceDetailQuery(id)

  const [updateCompliance, { isLoading: updatingCompliance }
  ] = useUpdateComplianceMutation();

  // methods
  const handleUpdateCompliance = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateCompliance({ ..._payload },).unwrap();
      toast.success("Compliance successfully updated!");
      navigate(`/app/crm/compliance/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Compliance !"
      );
    }
  };

  useAppMeta("Edit Compliance");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingCompliance || updatingCompliance}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ComplianceForm
          isBusy={loadingCompliance || updatingCompliance}
          complianceDetail={complianceDetail}
          onSubmit={handleUpdateCompliance}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default ComplianceEditScreen